import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import { fetchGetFormalOffers } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../../../../iwQueryClient/useStateKey';

export function useGetFormalOffer(offerId: string): TFormalOffer {
    const stateKey = useStateKey();

    const { data } = useQuery({
        queryKey: ['fetchGetFormalOffers', stateKey],
        queryFn: () => fetchGetFormalOffers({ stateKey }),
        select: (data) =>
            data.data?.formal_offers.find(
                (offer) => offer.offer_id === offerId
            ),
        suspense: true
    });

    if (!data) {
        const message = `useGetFormalOffer: formal offer not found: ${offerId}`;
        logError(message, { tags: TAGS.DE_LENDING });
        throw new Error(message);
    }

    return data;
}
